(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rlx-footer"]) return;
  try {
    
	class RlxFooter extends HTMLElement {
		constructor() {
			super();
			this.init()
		}

		init(){
			document.querySelector('.back-top').addEventListener('click', () => {
				window.scrollTo({
					top: 0,
					behavior: "smooth"
				});
			});
		}	
	}
	customElements.define('rlx-footer', RlxFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rlx-header"]) return;
  try {
    
	class RlxHeader extends HTMLElement {
		constructor() {
			super();

			this.init()
		}

		init(){
			this.nav = document.querySelector('.header-nav');
			this.navMobile = document.querySelector('.rlx-menu-button');
			this.wrapperNav = document.querySelector('.header-wrapper-nav');
			this.linkMenuMobile = document.querySelector('.rlx-menu-button'); 

			var navWidth = this.nav.getBoundingClientRect().width
			var wrapperNavWidth = this.wrapperNav.getBoundingClientRect().width;

			if(navWidth >= wrapperNavWidth){
				this.showBurgerMenu(true);
			} else {
				this.showBurgerMenu(false);
			}

			window.addEventListener("resize", () =>{
				navWidth = this.nav.getBoundingClientRect().width
				wrapperNavWidth = this.wrapperNav.getBoundingClientRect().width;

				if(navWidth >= wrapperNavWidth){
					this.showBurgerMenu(true);
				} else {
					this.showBurgerMenu(false);
				}
			});			

			this.linkMenuMobile.addEventListener('click', () => {
				this.toggleMenuMobile();
			});
		}

		showBurgerMenu(value){
			if(value === true){
				this.navMobile.classList.remove('md:hidden');
				this.nav.classList.remove('md:visible');
			}else{
				this.navMobile.classList.add('md:hidden');
				this.nav.classList.add('md:visible');
			}
		}

		toggleMenuMobile(){
			this.menuMobile = document.querySelector('.rlx-menu-mobile');
			this.menuMobile.classList.toggle('invisible');
		}		
	}
	customElements.define('rlx-header', RlxHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rlx-products-grid"]) return;
  try {
    
	class RlxProductGrid extends HTMLElement {
		constructor() {
			super();

			this.init()
		}

		init(){
			console.log('init')
			this.showMore = document.querySelector('.show-more');
			this.cardItems = document.querySelectorAll('.rlx-product-card');

			this.showMore.addEventListener('click', () => {
				this.showAllProducts();
			});
		}

		showAllProducts(){
			this.cardItems.forEach((item) =>{
				item.classList.remove('hidden');
			});
			this.showMore.classList.add('hidden');
		}		
	}
	customElements.define('rlx-product-grid', RlxProductGrid);

  } catch(e) { console.error(e); }
})();
})();
